module.exports = __webpack_public_path__ + "img/logo_transparent.78a05794.png";